import { AuthCard } from '@auth/components';
import { useAuthCallback } from '@auth/hooks/useAuthCallback';
import { withAppInsightsTracking } from '@soteria-ui/src/core/logging/withAppInsightsTracking';

import * as styles from './LoginCallbackPage.css';

/**
 * Authentication callback component
 * Handles the OAuth callback after the user authenticates with the provider
 */
export function LoginCallbackPage() {
  const { processing, errors } = useAuthCallback();

  return (
    <div className={styles.loginCallbackContainer}>
      <AuthCard
        error={errors}
        errorBannerTitle="There was an error processing your authentication:"
        isLoading={processing}
        loadingText="Processing authentication..."
      />
    </div>
  );
}

export const LoginCallbackPageComponent = withAppInsightsTracking(LoginCallbackPage, 'LoginCallbackPage');
